import PropTypes from 'prop-types';

const { string, number, bool, shape, arrayOf, oneOfType } = PropTypes;

export const SidebarProps = shape({
  show: bool,
  collapse: bool,
});

export const ThemeProps = shape({
  className: string,
});

export const RTLProps = shape({
  direction: string,
});

export const MemberProps = shape({
  id: string,
  name: string,
  order: number,
});

export const CustomFieldProps = shape({
  id: string,
  name: string,
  i18: string,
  description: string,
  parentId: string,
  type: string,
  size: number,
  default: bool,
  members: arrayOf(MemberProps),
  order: number,
});

export const ItemProps = shape({
  id: string,
  clientId: string,
  name: string,
  description: string,
  type: string,
  parentId: string,
  link: string,
  dateCreated: string,
  dateModyfied: string,
});

export const ClientProps = shape({
  clientNavisionId: string,
  id: string,
  name: string,
  cif: string,
  contactName: string,
  contactPhone: string,
  contactMail: string,
  direction: string,
  cp: string,
  state: string,
  local: string,
  login: string,
  pass: string,
  items: ItemProps,
});

export const DropdownOption = shape({
  value: oneOfType([string, number]),
  name: string,
});

export const CustomFolderProps = shape({
  clientNavisionId: string,
  id: string,
  name: string,
  type: string,
  parentId: string,
  isFile: bool,
  path: string,
});

export const IconProp = PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]);
